const HideState = {
  Respondent: 'respondent',
  Admin: 'admin',
  AdminPosition: 'admin_position'
};

export default HideState;
